import { useEffect } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { apiGetPolicyInfo } from "utils/API/TrxNowAPI";
import { PolicyLookupSpinner } from "webapp/components/PolicyLookupSpinner";
// import "./APIAMemberInformationForm.scss";
import { devLog } from "utils/devLog";

const policyMap = new Map();
function CRRMemberInformationForm(props) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [searchValue, setSearchValue] = useState(props.currState.MemberLookup.accountRef);

  const [last8Vin] = useState(props.currState.MemberLookup.last8Vin);
  const [decalNumber] = useState(props.currState.MemberLookup.decalNumber);
  const [memberNumber] = useState(props.currState.MemberLookup.memberNumber);
  const [make] = useState(props.currState.MemberLookup.make);
  const [model] = useState(props.currState.MemberLookup.model);
  const [year] = useState(props.currState.MemberLookup.year);
  const [color] = useState(props.currState.MemberLookup.color);
  const [firstName] = useState(props.currState.FirstName);
  const [lastName] = useState(props.currState.LastName);
  const [fullName] = useState(props.currState.MemberLookup.fullName);

  const [searchType, setSearchType] = useState(props.currState.MemberLookup.searchType);
  const [contractData, setContractData] = useState(undefined);
  const [selectedMember, setSelectedMember] = useState(contractData);
  const [partnerCode, setPartnerCode] = useState(props.currState.localGroup);

  useEffect(() => {
    // devLog(props);
    onSubmit();
  }, []);

  const onLoad = (success) => {
    if (typeof props.onLoad === "function") {
      props.onLoad(success);
    }
  };

  const onSelect = (member) => {
    // devLog("onSelect", member);
    setSelectedMember(member);
    if (!member) {
      return;
    }
    if (typeof props.onSelect === "function") {
      props.onSelect(member, member);
    }
  };

  const onSubmit = (e) => {
    setError("");
    // e.preventDefault();
    // devLog("Execute policy search...", searchValue);

    if (policyMap.has(searchValue)) {
      setContractData(policyMap.get(searchValue));
      setLoading(false);
      onLoad(true);
      // devLog("searchValue: " + searchValue);
      return;
    }

    const memberData = searchValue;
    // devLog("memberData: " + memberData);

    setLoading(true);
    //Lookup: Callout
    apiGetPolicyInfo({
      data: {
        providerRef: props.currState.providerRef,
        memberRef: props.currState.memberRef,
        fullName: fullName,
        searchType: searchType,
        memberNumber: memberNumber,
        last8Vin: last8Vin,
        firstName: firstName,
        lastName: lastName,
        partnerCode: partnerCode,
      },
      companyParams: props.currState.currentCompanyParams,
    })
      //Lookup: Success
      .then((json) => {
        // devLog("JSON", json);
        if (typeof json.data.memberInfo === "object") {
          if (!json.data.error) {
            setContractData(json.data.memberInfo);
            onLoad(true);
          } else {
            setError(json.data.error.message);
            onLoad(false);
          }
        } else if (typeof json.data.error === "object") {
          setError(json.data.error.message);
          policyMap.delete(searchValue);
          onLoad(false);
        } else {
          setError(t("APIA.PolicyInformation.UnableToFindMember"));
          policyMap.delete(searchValue);
          onLoad(false);
        }
        setLoading(false);
        onSelect(json.data.memberInfo);
      })

      //Lookup: Failed
      .catch((e) => {
        devLog("error", e);
        setLoading(false);
        setError(t("APIA.PolicyInformation.UnableToFindMember"));
        onLoad(false);
      });
  };

  const onUserBack = (e) => {
    e.preventDefault();
    if (typeof props.onUserBack === "function") {
      props.onUserBack();
    }
  };

  return (
    <>
      <div className="formContainer">
        {contractData ? (
          <div className="policyData">
            <div className="policyHeader">
              <h4>{t("description.ContractInformationHeader2")}</h4>
              <hr />
              <div className="policy-info-line">
                <b>{t("APIA.PolicyInformation.ConfirmCustomerYear")}:</b>{" "}
                {contractData.year ? contractData.year.toUpperCase() : ""}
              </div>
              <hr />
              <div className="policy-info-line">
                <b>{t("APIA.PolicyInformation.ConfirmCustomerMake")}:</b>{" "}
                {contractData.make ? contractData.make.toUpperCase() : ""}
              </div>

              <hr />
              <div className="policy-info-line">
                <b>{t("APIA.PolicyInformation.ConfirmCustomerModel")}:</b>{" "}
                {contractData.model ? contractData.model.toUpperCase() : ""}
              </div>
              <hr />
              <div className="policy-info-line">
                <b>{t("APIA.PolicyInformation.ConfirmCustomerColor")}:</b>{" "}
                {contractData.color ? contractData.color.toUpperCase() : ""}
              </div>
              <hr />
            </div>
            {/*First & Last Name*/}
            {/* <div className="vehicleHeader">
              <h4 className="slim">
                {t("BWC.PolicyInformation.MemberInformationHeader2")}
              </h4>
            </div>
            <div className="vehicle-list-container">
              <>
                <div
                  key={0}
                  value={contractData}
                  className={`vehicle-list-item ${
                    selectedMember === contractData ? "selected" : ""
                  }`}
                  onClick={(e) => {
                    onSelect(contractData);
                  }}
                >
                  <div value={contractData} className="vehicle-list-item-col-1">
                    <h5 value={contractData}>{contractData.Name}</h5>
                  </div>
                  <input
                    className="vehicleSelector"
                    type="radio"
                    name="policy-vehicle"
                    checked={selectedMember === contractData ? "selected" : ""}
                  />
                </div>
              </>
            </div> */}
          </div>
        ) : (
          <></>
        )}{" "}
      </div>
      {error ? (
        <div className="errorSection">
          <b className="error">{error}</b>
          <div>
            <button className="ui-btn" onClick={onUserBack}>
              {t("description.TryAgain")}
            </button>
          </div>
        </div>
      ) : (
        <></>
      )}
      {loading ? <PolicyLookupSpinner title={`ContractLookupTitleARI`} message={`PolicyLookupMessage`} /> : <></>}
    </>
  );
}

export default CRRMemberInformationForm;
